import * as React from 'react';
import { PaginationCardComponentHandler, PaginationCardComponentProps } from './paginationcardcomponent';
import { UIComponentViewImpl } from '../../uicomponentview';
import { UIDataModel, UIComponentState } from '../../uicomponent';
import { PaginationCardCSSStyle } from './paginationcardcss';

export class PaginationCardViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onSelectNext = this.onSelectNext.bind(this);
    }
    
    draw(props: PaginationCardComponentProps, state: UIComponentState, cssStyle: PaginationCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                <div onClick={this.onSelectNext} style={cssStyle.getInnerWrapperCSSStyle(props.selectedPageNumber === props.paginationIndex)}>
                    <div style={cssStyle.getPaginationIndexCSSStyle(props.selectedPageNumber === props.paginationIndex)}>
                        {props.paginationIndex}
                    </div>
                </div>
               
             </div>   
              
            
        );
    }

    onSelectNext():void
     {
        (this.getUIComponentHandler() as PaginationCardComponentHandler).onSelectNext();
     }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/pagination/paginationcard/paginationcardview.tsx